import { MtAccountUserSettings } from "server/models"
import { deepCopy } from "client/utils"
import { LoadDriveFileById } from "client/store"
import { GET, POST } from "client/store/utils"
import * as types from "./types"
import { initUserSettings } from "./reducers"


export const LoadUserSettings = (
    userId: number,
    accountId: number,
): Promise<types.UserSettings> => (
    GET(`/mtAccountUserSettings/userId/${userId}/accountId/${accountId}`)
    .then((data: MtAccountUserSettings) => {
        const oldSettings = data && data.settings ? JSON.parse(data.settings) : {}
        const newSettings = deepCopy(initUserSettings)

        Object.keys(newSettings).forEach((module) => {
            Object.keys(newSettings[module]).forEach((param) => {
                if (oldSettings[module] && oldSettings[module][param] !== undefined) {
                    newSettings[module][param] = oldSettings[module][param]
                }
            })
        })

        return LoadDriveFileById(newSettings.project.defaultLogoId)
        .then((file) => {
            newSettings.project.defaultLogo = file
            return newSettings
        })
    })
)

export const SaveUserSettings = (
    userId: number,
    accountId: number,
    settings: types.UserSettings,
) => {
    const data: MtAccountUserSettings = {
        userId,
        accountId,
        settings: JSON.stringify(settings),
    }
    return POST(
        "/mtAccountUserSettings/save",
        JSON.stringify(data),
    )
}
